import { loadableWithFallback } from '@vision/ui/utils';
import type { BarChart2Props } from './BarChart2';

export const BarChart2 = loadableWithFallback<BarChart2Props>(() => import('./BarChart2'));
